import React, { useState, useEffect } from 'react';
import '../../../urunDiv.css';
import '../sicak-kahveler/KahveDetay.css';
import form from '../../../../assets/menu/icecekler/sicak-icecekler/form.jpeg';

const Form = () => {
  const [isPhone, setIsPhone] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsPhone(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Form bilgileri
  const icecek = {
    name: 'Form',
    price: '₺239,90',
    image: form
  };

  const aciklama = 'Cinnema, darülfülfül, kiraz sapı, biberiye, mate, mısır püskülü, funda, barut ağacı, sinirli ot, ısırgan otu, enginar yaprağı, limon kurusu, limon özütü';

  return (
    isPhone ? (
      <div className="americano-detay-container">
        {/* Product Section */}
        <div className="product-section">
          <div className="product-image-container">
            <img src={icecek.image} alt={icecek.name} className="product-image" />
            <div className="product-overlay">
              <div className="product-name-price">{icecek.name} - {icecek.price}</div>
            </div>
          </div>
          
          <div className="product-description">
            <p>{aciklama}</p>
          </div>
        </div>
      </div>
    ) : (
      <div className="urun-detay-container-computer">
        {/* Product Section */}
        <div className="product-section">
          <div className="product-image-container">
            <img src={icecek.image} alt={icecek.name} className="product-image" />
            <div className="product-overlay">
              <div className="product-name-price">{icecek.name} - {icecek.price}</div>
            </div>
          </div>
          
          <div className="product-description-computer">
            <p>{aciklama}</p>
          </div>
        </div>
      </div>
    )
  );
};

export default Form;
